<template>

<div v-if="this.model === 'Shared'">
  <shared-model :row-data="billData" :title="title" :site-id="siteId" :tax="tax" />
</div>
<div v-else>
  <indivdual-model :row-data="billData" :title="title" :site-id="siteId" :tax="tax" />
</div>

</template>

<script>

import {settings} from '@/components/Data'

import NumberMixins from '@/mixins/NumberMixins'

import IndivdualModel from '@/components/utility/sharing/IndivualRatesModel'
import SharedModel from '@/components/utility/sharing/SharedRatesModel'

export default {

  mixins: [NumberMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    },

    siteId: {
      type: Number,
      default: null
    },

    title: {
      type: String,
      default: null
    },

    tax: {
      type: Boolean,
      default: true
    }

  },

  watch: {
    rowData: function (value) {
      this.$forceUpdate()
    }
  },

  components: {
    IndivdualModel,
    SharedModel
  },

  data () {
    return {
      billData: this.rowData,
      utilLabel: this.getUtilLabel(this.rowData),
      taxLabel: settings.taxName,
      model: settings.utilRatesModel
    }
  }

}

</script>



// WEBPACK FOOTER //
// UtilitySharingTable.vue?b3bac888